import { Container, Section } from '@components';

const Analytics = () => {
  return (
    <div className="bg-neutral-soft-gray min-h-screen">
      <Section>
        <Container>
          <div className="text-center py-16">
            <h1 className="text-h2 text-primary-navy mb-4">Analytics</h1>
            <p className="text-body text-neutral-medium-gray">
              Coming in Phase 6 - Analytics Dashboard
            </p>
          </div>
        </Container>
      </Section>
    </div>
  );
};

export default Analytics;
